// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { color, hideElementOnPrint, xScreen } from "@keller/XDL/Utilities";
import React from "react";
import styled, { css } from "styled-components";

interface SharedPrintStyles {
    mainContainer?: GridContainerProps;
    container?: GridContainerProps;
    addressGridWrapper?: GridItemProps;
    billingAddressGridItem?: GridItemProps;
    shippingAddressGridItem?: GridItemProps;
    orderConfirmationTotalGridItem?: GridItemProps;
    notesGridItem?: GridItemProps;
    hideOnPrint?: GridItemProps;
    richContentOnPrintGridItem?: GridItemProps;
    dividerGridItem?: GridItemProps;
}

export const sharedPrintStyles: SharedPrintStyles = {
    mainContainer: { gap: 16 },
    container: {
        gap: 16,
        css: css`
            @media print {
                ${GridOffset} {
                    display: flex;
                }
            }
        `,
    },
    addressGridWrapper: {
        width: 12,
        printWidth: 8,
    },
    billingAddressGridItem: {
        width: [12, 12, 5.1, 3.6, 3.6] as any,
        printWidth: 6,
        css: css`
            &&& {
                ${xScreen("lte", "sm")} {
                    margin-bottom: 8px;
                }
                @media print {
                    max-width: unset;
                    flex-basis: unset;
                    margin-right: 0;
                }
            }
        `,
    },
    shippingAddressGridItem: {
        width: [12, 12, 5.1, 3.6, 3.6] as any,
        printWidth: 6,
        css: css`
            &&& {
                ${xScreen("lte", "sm")} {
                    margin-bottom: 8px;
                }
                @media print {
                    order: -1;
                    max-width: unset;
                    flex-basis: unset;
                    margin-right: 0;
                }
            }
        `,
    },
    orderConfirmationTotalGridItem: {
        width: 4,
        css: css`
            display: none;
            @media print {
                padding-left: 12px;
                display: inline-block;
            }
        `,
    },
    notesGridItem: {
        width: 12,
        css: css`
            &&& {
                margin-top: 16px;

                ${hideElementOnPrint}
            }
        `,
    },
    hideOnPrint: {
        width: 12,
        css: css`
            ${hideElementOnPrint}
        `,
    },
    richContentOnPrintGridItem: {
        width: 12,
        css: css`
            &&& {
                display: none;
                @media print {
                    display: inline-block;
                    br {
                        display: none;
                    }
                    * {
                        margin-bottom: 0;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 1.5;
                    }
                }
            }
        `,
    },
    dividerGridItem: {
        width: 12,
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            &&& {
                margin-top: 32px;
                margin-bottom: 15px;
                @media print {
                    margin-top: 8px;
                    margin-bottom: 0;
                }
            }
        `,
    },
};

const HR = styled.hr`
    border: none;
    border-top: 1px solid ${color("common.ui5")};
    width: 100%;
`;

const Seperator = () => {
    return (
        <GridItem {...sharedPrintStyles.dividerGridItem}>
            <HR />
        </GridItem>
    );
};
export default Seperator;
